import React from "react";
import css from "./item.module.css";
import TrafficLights from "../../TrafficLights";

function Item({ contract_id, contract_name, summary }) {
  return (
    <div className={css.item}>
      <div className={css.cardcontainer}>
        <h2 className={css.contractname}>{contract_name}</h2>
        <p className={css.contractID}>Contract ID: {contract_id}</p>
        <p className={css.summary}>{summary}</p>
      </div>
      <div className={css.trafficcontainer}>
        <TrafficLights
          isClicked={false}
          setIsClicked={val => {
            return val;
          }}
        />
      </div>
    </div>
  );
}

export default Item;
